import { render } from "./Circles.vue?vue&type=template&id=68c279b8"
import script from "./Circles.vue?vue&type=script&lang=js"
export * from "./Circles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__